<template>
  <!-- <feather-icon
      icon="CircleIcon"
      :svgClasses="['fill-current h-4 w-4', textColor]"
    /> -->

  <vs-chip class="ag-grid-cell-chip" :color="textColor(params.value)">
    <span>{{ getStatus(params.value) }}</span>
  </vs-chip>
</template>

<script>
export default {
  name: 'CellRendererVerified',
  computed: {},
  methods: {
    textColor (val) {
      return val === 1 ? 'primary' : 'grey'
    },
    getStatus (value) {
      if (value === 1) return 'проверено'
      else return 'не проверено'
    }
  }
}
</script>
